import { parseClusterResponse, parseSystemDate, getBqnIdCmdPart } from "common/api";
import { parseDate } from "../utils";

export function parseMemSystemTotal(response) {
  const [header, ...rows] = response.trim().split("\n");
  const attrs = rows[0].trim().split(/\s+/);
  return Number(attrs[1]) / 1024;
}

export function parseMemUsagePoolTotal(response) {
  const [header, ...rows] = response.trim(/\s/).split("\n");
  const total = {};
  for (const row of rows) {
    const attrs = row.trim().split(/\s+/);
    if (!isNaN(attrs[0])) {
      const bqnId = attrs[0];
      if (total[bqnId]) {
        total[bqnId] += Number(attrs[2]) / 1024;
      } else {
        total[bqnId] = Number(attrs[2]) / 1024;
      }
    }
  }
  return total;
}

export function parseMemUsageDpdkTotal(response) {
  const [header, ...rows] = response.trim(/\s/).split("\n");
  const output = {};

  for(const row of rows){
    const attrs = row.trim().split(/\s+/);
    if(!isNaN(attrs[0])){
      const bqnId = attrs[0];
      const value = attrs[3] == "n/a" ? 0.0 : Number(attrs[3])
      if(output[bqnId]){
        output[bqnId].push(value)
      }else{
        output[bqnId] = [value]
      }
    }
  }

  return output;
}

function parserUserItemF(it, i, totals) {
  return (it * 100) / totals[i - 1];
}

export const parseStatsMemData = (response, period, totals) => {
  const [header, ...rows] = response.trim(/\s/).split("\n");
  const [, ...keys] = header.split(/\s+/);
  const keysSeries = keys.map((key) => {
    const chunks = key.split("-").map((item) => {
      return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
    });
    chunks.pop();
    return chunks.join("-");
  });

  const newKeys = ["time", ...keysSeries];
  const { System, Mpool, Dpdk } = totals;

  if (rows.length === 0) {
    return { fields: keysSeries, items: [] };
  }

  const newRows = rows.map((row) => {
    return row.split(/\s+/).reduce((acc, value, index) => {
      if (index === 0) {
        acc[newKeys[index]] = parseDate(value);
      } else {
        acc[newKeys[index]] = parserUserItemF(value, index, [
          System,
          Mpool,
          ...Dpdk,
        ]);
      }
      return acc;
    }, {});
  });

  return { fields: keysSeries, items: newRows };
};

export const getMemoryStatsLines = (lines = 288, mode, bqnId) =>
  ifCl.run(`show statistics memory lines ${lines}${getBqnIdCmdPart(mode, bqnId)}`)

export const memoryUsageSystemDateRetrieval = (bqnId) =>
  Promise.all([
    ifCl.run("show system memory").then(response => parseClusterResponse(response, parseMemSystemTotal, bqnId)),
    ifCl.run("show pkteng memory").then(parseMemUsagePoolTotal),
    ifCl.run("show pkteng memory dpdk").then(parseMemUsageDpdkTotal),
    ifCl.run("show system date").then(parseSystemDate)
  ]);
